import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerContractDetails.css';
import { EditFormButton,TextField, AutocompleteField,SelectField,DateField,MessageBox } from 'component-lib';
import { RoleConfiguration,TranslateGender,DateTimeHelper } from 'utils-lib';
import { StreetsModel, RequestAjaxClass, AdditionalAddressesModel } from 'models-lib';


var moment = require('moment');
moment().format();
var getStreets = true;
var streetIndex = 0;
var streetArrayLength = 0;

class CustomerLegalGuardianDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Edit = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Address = this.props.data[0];
        this.StreetsModel = new StreetsModel([this], "StreetsCustomer", this.Request);
        this.AdditionalAddressModel = new AdditionalAddressesModel([this]);
    }

    componentWillMount(){
      this.AdditionalAddressModel.Address = this.props.data[0]; 
      localStorage.setItem('adress', JSON.stringify(this.props.data[0]));
    }

    componentDidMount(){
      this.setAddress();
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      //this.StreetsModel.SetRequest(this.Request);
      this.AdditionalAddressModel.SetRequest(this.Request);

      let reqFields = [this.refs.name, this.refs.firstName,this.refs.dateOfBirth,this.refs.zip, this.refs.city,this.refs.houseNumber, this.refs.street];

      let from = '';
      let to = '';
      
      if (moment(this.AdditionalAddressModel.Address.ValidFrom).isBefore(moment([1900,1,1]))){
        from = Vas.Resources.Labels["Unlimited"];
      } else {
        from = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.ValidFrom,true,localStorage.getItem('vas_language')));
      }
      
      if (moment(this.AdditionalAddressModel.Address.ValidUntil).isBefore(moment([1900,1,1]))){
        to = Vas.Resources.Labels["Unlimited"];
      } else {
        to = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.ValidUntil,true,localStorage.getItem('vas_language')));
      }

      this.setState({ requiredFields:reqFields, 
        //requiredSelectField:[this.refs.gender],
        ValidFrom: from,
        ValidTo: to },()=>{
          this.refs.validFrom.setState({ Value : from });
          this.refs.validTo.setState({ Value : to });
        });
    }

    componentDidUpdate(){
        if (this.state.Edit === false)
        {
          getStreets = true;

            this.refs.name.setState({ editable:false });
            this.refs.firstName.setState({ editable:false });
            if(this.AdditionalAddressModel !== undefined){
              if(this.AdditionalAddressModel.Address !== undefined){
                if(this.AdditionalAddressModel.Address.DateOfBirth !== undefined){
                  if(this.AdditionalAddressModel.Address.DateOfBirth.length > 0){
                    document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.DateOfBirth,true,localStorage.getItem('vas_language')));
                  }
                }
              }
            }
            
            this.refs.zip.setState({ editable:false });
            this.refs.city.setState({ editable:false });
            this.refs.street.setState({ editable:false });
            this.refs.houseNumber.setState({ editable:false });
            this.refs.houseNumberAddition.setState({ editable:false });            
        }
        else
        {
            this.refs.name.setState({ editable:true });
            this.refs.firstName.setState({ editable:true });
            this.refs.dateOfBirth.setState({ editable:true });
            this.refs.zip.setState({ editable:true });
            this.refs.city.setState({ editable:true });
            this.refs.street.setState({ editable:true });
            this.refs.houseNumber.setState({ editable:true });
            this.refs.houseNumberAddition.setState({ editable:true });

            document.getElementById("Street").selectedIndex = streetIndex < streetArrayLength ? streetIndex + 1 : streetIndex;
        }
    }

    componentWillUnmount(){
      localStorage.removeItem('adress');
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "StreetsCustomer"){

            let streetSelection = [];
    
            if(this.StreetsModel.Streets.length > 0){
    
              let streetArray = this.StreetsModel.Streets;
    
              streetArrayLength = streetArray.length;
    
              for(let i = 0; i < streetArray.length; i++){
                if(streetArray[i] == this.AdditionalAddressModel.Address.Street){
                    streetIndex = i;
                }
                streetSelection.push({ Key: streetArray[i], Display: streetArray[i] });
              }      
            }
    
            this.setState({StreetValues : streetSelection});
             if(this.refs.street){
               this.refs.street.setState({Data:streetSelection});
             }
    
            //this.setState({oldZipstreet: this.StreetsModel.PostCode, oldCitystreet: this.StreetsModel.City });
          }
          else if(observer === "Streets"){
            me.refs.street.setState({ Data: this.StreetsModel.Streets, Icon :'',placeholder:'' });
            me.setState({ oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
          }
          else if(observer === "AddressPUT"){
            me.props.reference.load(me.props.table.PrepareSendData());
            this.setAddress();
          }
        });
    }

    setAddress(){
      document.getElementById("Name1").value = this.AdditionalAddressModel.Address.Name1;
      document.getElementById("Name2").value = this.AdditionalAddressModel.Address.Name2;
      document.getElementById('Gender').value = this.AdditionalAddressModel.Address.Gender;
      document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.DateOfBirth,true,localStorage.getItem('vas_language')));
      document.getElementById("Zip").value = this.AdditionalAddressModel.Address.Zip;
      document.getElementById("City").value = this.AdditionalAddressModel.Address.City;
      document.getElementById("Street").value = this.AdditionalAddressModel.Address.Street;
      document.getElementById("HouseNumber").value = this.AdditionalAddressModel.Address.HouseNumber;
      document.getElementById("HouseNumberAddition").value = this.AdditionalAddressModel.Address.HouseNumberAddition;
    }

    CustomerUpdate()
    {                        
      if (this.checkFields()=== true){
        this.AdditionalAddressModel.UpdateAdditionalAddress();
        this.setState({oldCity:'',oldZip:''});
      } else {
        this.Cancel();
        
      }
    }

    Cancel(oldValues){
      this.setState({oldCity:'',oldZip:''},()=>{
        this.AdditionalAddressModel.Address = {};
        this.AdditionalAddressModel.Address = JSON.parse(localStorage.getItem('adress'));
        this.setAddress();
      });
    }

    checkFields(){
      let count;
      if (this.state.requiredFields){
        count = this.state.requiredFields.length;
        
        let filled = 0; //Anzahl der korrekt gefüllten Feldern 
        for (let i = 0;i < this.state.requiredFields.length;i++){
          if (this.state.requiredFields[i]){
            if ((document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0
              || document.getElementById(this.state.requiredFields[i].props.Id).placeholder.length > 0) === true){
                if(!(/^\s+$/).test(document.getElementById(this.state.requiredFields[i].props.Id).value)){
                  filled++;
                }
            }
          }
        }
  
        // for (let k = 0; k < this.state.requiredSelectField.length;k++){
        //   if (this.state.requiredSelectField[k]){
        //     if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
        //       filled++;
        //     }
        //   }
        // }
  
        if (filled < count){
         
          ReactDOM.render(<MessageBox
            Message={Vas.Resources.Labels["NotAllFields"]}
            Title={Vas.Resources.Titles["Note"]}
            />
            ,document.getElementById('messageContainer'));
            return false;
        } else {
          return true;
        }
      }
    }

    getStreets()
    {
      let me = this;
      me.refs.street.setState({ Icon:"Loop" });

      if ((this.AdditionalAddressModel.Address.Zip !== me.state.oldZip)||(this.AdditionalAddressModel.Address.City !== me.state.oldCity)){
        me.refs.street.setState({ Data: [], Icon : '' });
        document.getElementById("Street").value = '';
      }

      if (this.AdditionalAddressModel.Address.City || this.AdditionalAddressModel.Address.Zip){
        let city = '';
        let zip = '';
        if (this.AdditionalAddressModel.Address){
          city=this.AdditionalAddressModel.Address.City;
        } 
        if (this.AdditionalAddressModel.Address.Zip){
          zip=this.AdditionalAddressModel.Address.Zip;
        } 

        this.StreetsModel.GetStreets(city,zip);
      }
    }

    bindStreets(){
      if(this.state.Edit && getStreets){
        this.getStreets();
  
        getStreets = false;
      }
    }

    render()
    {
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        
        let right = '';
        if (role === "1"){
            if (rights[1]){
                right =  rights[1];
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
                right = rights[0];
            }
        }
        
        let name = '';
        let firstName = '';
        let zip = '';
        let city = '';
        let street = '';
        let houseNumber = '';
        let houseNumberAddition = '';
        let gender = '';
        let dateOfBirth = '';
        let validFrom = '';
        let validTo = '';

        let min = moment();
        let maxValueLegalGuardian = moment([min.year() - 24, min.month(), min.date() + 1]);

        name = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"name"}
          Editable={false}
          Id={"Name1"}
          Label={Vas.Resources.Labels["Name"]}
          OnBlur={()=>{this.AdditionalAddressModel.Address.Name1 = $("#Name1").val() ;}}
        />);
        firstName = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"firstName"}
          Editable={false}
          Id={"Name2"}
          Label={Vas.Resources.Labels["FirstName"]}
          OnBlur={()=>{this.AdditionalAddressModel.Address.Name2 = $("#Name2").val(); }}
          />);
        gender = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Editable={false} 
          Id={"Gender"} 
          Label={Vas.Resources.Labels["Gender"]} 
          ref={"gender"} 
          Value={TranslateGender.Translate(this.AdditionalAddressModel.Address.Gender,localStorage.getItem('vas_language'))}
        />);
        dateOfBirth = (<TextField 
          AppURL={Vas.ApplicationUrl}
          Editable={false} 
          Id={"DateOfBirth"} 
          Label={Vas.Resources.Labels["DateOfBirth"]} 
          ref={"dateOfBirth"}
        />);
        zip = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"zip"}
          Editable={false}
          Id={"Zip"}
          Label={Vas.Resources.Labels["Zip"]}
          OnChange={()=>{if ($("#Zip").val().length < 0)
                        {$("#Zip").val(this.AdditionalAddressModel.Address.Zip);} 
                      else {this.AdditionalAddressModel.Address.Zip= $("#Zip").val();}
                      this.getStreets(); streetIndex = -1;
          }}
          />);
        city = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"city"}
          Editable={false}
          Id={"City"}
          Label={Vas.Resources.Labels["City"]}
          OnChange={()=>{if ($("#City").val().length < 0)
                        {$("#City").val(this.AdditionalAddressModel.Address.City);} 
                      else {this.AdditionalAddressModel.Address.City = $("#City").val(); }
                      this.getStreets(); streetIndex = -1;
          }}
          />);
        street = (<AutocompleteField 
          AppURL={Vas.ApplicationUrl}
          Data={this.state.streets} 
          editable={false}
          Float={'left'}
          Id={"Street"}
          IsRequired={true} 
          Label={Vas.Resources.Labels["Street"]}
          MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
          Modus={"Street"}
          OnBlur={()=>{this.AdditionalAddressModel.Address.Street = $("#Street").val(); }}
          ref={"street"}
          TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
          Tooltip={Vas.Resources.Tooltips["Street"]}  
          Width={346}
          TimeOutTime={Vas.TimeOutTime} 
        />);
        houseNumber = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"houseNumber"}
          Editable={false}
          Id={"HouseNumber"}
          Label={Vas.Resources.Labels["HouseNumber"]}
          OnBlur={()=>{this.AdditionalAddressModel.Address.HouseNumber = $("#HouseNumber").val();}}
          />);
        houseNumberAddition = (<TextField
          AppURL={Vas.ApplicationUrl}
          ref={"houseNumberAddition"}
          Editable={false}
          Id={"HouseNumberAddition"}
          Label={Vas.Resources.Labels["HouseNumberAddition"]}
          OnBlur={()=>{ this.AdditionalAddressModel.Address.HouseNumberAddition = $("#HouseNumberAddition").val(); }} />);
        validFrom = (<TextField 
          AppURL={Vas.ApplicationUrl}
          Editable={false} 
          Id={"ValidFrom"} 
          Label={Vas.Resources.Labels["ValidFrom"]} 
          ref={"validFrom"}
        />);
        validTo = (<TextField 
          AppURL={Vas.ApplicationUrl}
          Editable={false} 
          Id={"ValidTo"} 
          Label={Vas.Resources.Labels["ValidTo"]} 
          ref={"validTo"}
        />);
        if (this.state.Edit === true){

          street = (<SelectField
            AppURL={Vas.ApplicationUrl}
            TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
            me={this}
            Width={350}
            ref={"street"}
            Id={"Street"}
            Float={'left'} 
            IsRequired={true}
            editable={true}
            Modus={"Street"}
            Data={this.StreetValues}
            Label={Vas.Resources.Labels["Street"]}
            OnBlur={()=>{this.AdditionalAddressModel.Address.Street = $("#Street").val();}}
            Tooltip={Vas.Resources.Tooltips["Street"]}
            TimeOutTime={Vas.TimeOutTime}/>);

          dateOfBirth = (<DateField 
            AppURL={Vas.ApplicationUrl}
            Editable={true}
            FalseDateText={Vas.Resources.Labels["DateNotValid"]}
            FalseDateTitle={Vas.Resources.Titles["Note"]}
            Id={"DateOfBirth"}
            IsRequired={true}
            Label={Vas.Resources.Labels["DateOfBirth"]}
            Language={localStorage.getItem("vas_language")}
            MaxValue={maxValueLegalGuardian}
            OnBlur={()=>{if($("#DateOfBirth").val().length === 0){
              $("#DateOfBirth").val(DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.DateOfBirth,true,localStorage.getItem('vas_language'))));
            }else {
              let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language')) ;
              this.AdditionalAddressModel.Address.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00"); 
            }
          }}
            ref={"dateOfBirth"}
            Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
            FalseMaxDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}
            FalseMinDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}
            Placeholder={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.AdditionalAddressModel.Address.DateOfBirth,true,localStorage.getItem('vas_language')))}
          />);

          gender = (<SelectField 
            AppURL={Vas.ApplicationUrl} 
            Data={[{ Key: 'männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'weiblich', Display: Vas.Resources.Labels["Female"] }]}
            Default={this.AdditionalAddressModel.Address.Gender}
            Id={"Gender"}
            IsRequired={true}
            Label={Vas.Resources.Labels["Gender"]}
            OnChange={()=>{
              if(document.getElementById('Gender').selectedIndex > 0){
                this.AdditionalAddressModel.Address.Gender = TranslateGender.Translate($("#Gender").val(),localStorage.getItem('vas_language'));
              }
            }}
            ref={"gender"}
            Tooltip={Vas.Resources.Tooltips["Gender"]}
            SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]} />);
        }
        
        return (<div className={""}>
          <table>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["Details"]}</b></td>
                <td><EditFormButton
                  AppURL={Vas.ApplicationUrl}
                  ref={"EditFormButton"}
                  base={this}
                  curr={this.state.data}
                  id={this.props.id}
                  Right={right} /></td>
              </tr>
              <tr>
                <td>{name}</td>
                <td>{firstName}</td>
              </tr>
              <tr>
                <td>{gender}</td>
                <td>{dateOfBirth}</td>
              </tr>
              <tr>
                <td>{zip}</td>
                <td>{city} </td>
              </tr>
              <tr>
                <td colSpan={2} onBlur={this.bindStreets()}>{street}</td>
                        
              </tr>
              <tr>
                <td>{houseNumber}</td>
                <td>{houseNumberAddition} </td>
              </tr>
              <tr>
                <td>{validFrom}</td>
                <td>{validTo}</td>
              </tr>
            </tbody>
          </table>

        </div>);
    }
}
export default CustomerLegalGuardianDetails;
